import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_GUESTBOOK_API_URL || 'http://localhost:3001/api/entries';

function GuestBook() {
	const [name, setName] = useState('');
	const [message, setMessage] = useState('');
	const [entries, setEntries] = useState([]);
	const [status, setStatus] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const fetchEntries = async () => {
		setIsLoading(true);
		setStatus('');

		try {
			const res = await fetch(API_URL);
			const data = await res.json();

			if (!res.ok) {
				throw new Error(data.error || 'Could not load guestbook entries');
			}

			setEntries(data);
		} catch (error) {
			console.error('Error fetching entries:', error);
			setStatus('Guestbook backend is not reachable. Start guestbook-backend on port 3001.');
		} finally {
			setIsLoading(false);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		const newEntry = { name: name.trim(), message: message.trim() };

		if (!newEntry.name || !newEntry.message) {
			setStatus('Please add both your name and a message.');
			return;
		}

		setIsSubmitting(true);
		setStatus('');

		try {
			const res = await fetch(API_URL, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(newEntry),
			});
			const data = await res.json();

			if (!res.ok) {
				throw new Error(data.error || 'Could not save guestbook entry');
			}

			setName('');
			setMessage('');
			setStatus('Thanks for signing the guestbook.');
			await fetchEntries();
		} catch (error) {
			console.error('Error submitting entry:', error);
			setStatus(error.message);
		} finally {
			setIsSubmitting(false);
		}
	};

	useEffect(() => {
		fetchEntries();
	}, []);

	return (
		<div
			style={{
				maxWidth: '600px',
				margin: '2rem auto',
				textAlign: 'left'
			}}
		>
			<h2>Guest Book</h2>
			<form onSubmit={handleSubmit}>
				<input
					type="text"
					placeholder="Your Name"
					value={name}
					onChange={(e) => setName(e.target.value)}
					style={{
						width: '100%',
						padding: '0.5rem',
						marginBottom: '1rem'
					}}
				/>
				<textarea
					placeholder="Say something nice (please!)"
					value={message}
					onChange={(e) => setMessage(e.target.value)}
					style={{
						width: '100%',
						height: '100px',
						padding: '0.5rem',
						marginBottom: '1rem'
					}}
				/>
				<button
					type="submit"
					disabled={isSubmitting}
					style={{
						padding: '0.5rem 1rem',
					}}
				>
					{isSubmitting ? 'Submitting...' : 'Submit'}
				</button>

				{status && <p>{status}</p>}
				{isLoading && <p>Loading guestbook...</p>}

				<ul
					style={{
						listStyleType: 'none',
						padding: 0,
					}}
				>
					{entries.map((entry) => (
						<li key={entry.id} style={{ marginBottom: '1rem' }}>
							<strong>{entry.name}</strong>: {entry.message}
						</li>
					))}
				</ul>
			</form>
		</div>
	)
}

export default GuestBook;
